// removed by extract-text-webpack-plugin
module.exports = {"breadcrumbs":"Breadcrumbs-module-breadcrumbs-3qwVR","item":"Breadcrumbs-module-item-2qvrm","link":"Breadcrumbs-module-link-1f7sg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Breadcrumbs/Breadcrumbs.module.scss
// module id = 948
// module chunks = 0